import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const mimasGemini: IProductData = {
  id: "wesaudio-mimas-gemini",
  name: "WesAudio _Mimas Gemini",
  description: "Fully Analog FET Stereo Pairs with digital recall",
  images: ["/img/wesaudio_mimas_gemini_front.png", "/img/wesaudio_mimas_gemini_side.png", "/img/wesaudio_mimas_gemini_left.png"],
  details: [{
    label: "Description",
    markdown: `
The _MIMAS Stereo Pair delivers a true stereo compression experience, ensuring precise andconsistent performance across both channels.  
Thanks to Dynamic Link Technology, the sidechain signal levels are dynamically adjusted via a specialized potentiometer, automatically compensating for component tolerances.  
This ensures perfect alignment between both units, maintaining accurate stereo imaging without unwanted drift.  
`
  }, {
    label: "Key Features",
    markdown: `
### _MIMAS Gemini: A True Stereo Compression Experience
- 100% analog FET compressor (1176-style) with 24dBu headroom for pristine audio quality.
- Two units fully calibrated for true stereo operation using the dedicated stereo plugin.
- Four ratio settings including the legendary “All Buttons In” mode and any combination.
- New, modern DAW plugin design tailored to meet the demands of professional audio engineers.
- Fully linked parameters via dedicated software—adjustments on one channel automatically update the linked unit.
- Selectable compression modes: True stereo compression or dual mono operation, switchable via the SC LINK button on the front panel.
- Carnhill transformers for enhanced audio quality.
- 500 Series and ng500 Series compatible.
- Total recall and plugin control for easy session management.
- Analog automation for seamless DAW integration.
`
  }, {
    label: "Specifications",
    markdown: `
- 100% analog FET compressor (1176-style) with 24dBu headroom for pristine audio quality.
- Two units fully calibrated for true stereo operation using the dedicated stereo plugin.
- Full Total Recall & plugin control, compatible with most DAWs for seamless workflow integration.
- New, modern DAW plugin design tailored to meet the demands of professional audio engineers.
- Fully linked parameters via dedicated software—adjustments on one channel automatically update the linked unit.
- Selectable compression modes: True stereo compression or dual mono operation, switchable via the SC LINK button on the front panel.
- _MIMAS features Carnhill transformers, forming the foundation of its sound.
- Fully balanced analog device with +24dBu headroom (IN/OUT). using the dedicated stereo plugin.
- Four ratio settings including the legendary “All Buttons In” mode. most DAWs for seamless workflow integration.
- Interstage Carnhill transformers for enhanced audio quality. the demands of professional audio engineers.
- Saturation mode with a single knob to add color and character without compression. automatically update the linked unit.
- Hardware A/B functionality for comparing settings.
- Total Recall and plugin control for seamless session management.
- Analog automation for precise DAW integration.
- Four touch-sensitive encoders for intuitive control.
- Interstage Carnhill transformers for added depth in sound.
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://wesaudio.com/product/_mimas-gemini/" target="_blank">https://wesaudio.com/product/_mimas-gemini/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.DUAL_SLOT, HASHTAGS.NEXT_GEN, HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.API_500],
    manufacturer: BRAND.WESAUDIO,
  },
  videos: []
}